import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "PagesModule"
const debug = false

export class PagesModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.PAGES, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Pages"
        this.description                = "The Pages module provides a flexible platform for creating, sharing, and managing custom content within projects. It allows users to craft personalized pages that can include text, images, and other multimedia elements, facilitating better communication and documentation. Ideal for consolidating project information, guidelines, and resources in a centralized location, this module enhances accessibility and collaboration across teams."
        this.svgIcon                    = "isvg-pages"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Productivity & Collaboration"
        this.settingsUrl                = "settings/pages"
        this.parentSection              = SettingsParentSection.PRODUCTIVITY

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.hasStatus                  = true
        this.isComingSoon               = false

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}